export { default } from './modules/TimeAgo.js'

// I guess these two are deprecated.
export {
	intlDateTimeFormatSupported as intlDateTimeFormatSupported,
	intlDateTimeFormatSupportedLocale as intlDateTimeFormatSupportedLocale
} from './modules/locale.js'